module.exports = __webpack_public_path__ + "img/hat1_6a3_1.361e25d0.svg";